import React, {useEffect, useMemo, useState} from "react";
import useFilterHandler from "../../../../hooks/useFilterHandler";
import {useQuery} from "react-query";
import {Box, Grid, ThemeProvider} from "@mui/material";
import Heading from "../../../../components/shared/Heading";
import theme from "../../../../mui-theme";
import {SEText} from "../../../../components/SEText";
import {AtendimentosSSEServiceInterface} from "../../services";
import {useLocation, useHistory} from "react-router-dom";

interface TabItem {
    id: string;
    label: string;
    component: React.ElementType;
}

interface ReportWrapperProps {
    title: string;
    service: AtendimentosSSEServiceInterface;
    queryKey: string;
    tipoAtendimento: string;
    exportFilenamePrefix: string;
    tabs: TabItem[];
}

export const ReportWrapper = ({
                                  title,
                                  service,
                                  queryKey,
                                  tipoAtendimento,
                                  exportFilenamePrefix,
                                  tabs,
                              }: ReportWrapperProps) => {
    const {setFilterOptions} = useFilterHandler();
    const location = useLocation();
    const history = useHistory();

    const knownTabIds = tabs.map((t) => t.id);
    const currentTabId = location.pathname.split("/").pop();

    // Tab válido vindo da URL ou o primeiro
    const initialTab = tabs.find(tab => tab.id === currentTabId) || tabs[0];
    const [tabSelected, setTabSelected] = useState<string>(initialTab.label);

    // Atualiza a URL quando tabSelected muda
    useEffect(() => {
        const selectedTab = tabs.find((tab) => tab.label === tabSelected);
        if (!selectedTab) return;

        const pathParts = location.pathname.split("/");
        const lastPart = pathParts[pathParts.length - 1];
        const isLastPartTab = knownTabIds.includes(lastPart);

        const basePath = isLastPartTab
            ? pathParts.slice(0, -1).join("/")
            : location.pathname;

        const nextPath = `${basePath}/${selectedTab.id}`;

        if (location.pathname !== nextPath) {
            history.replace(nextPath);
        }
        // eslint-disable-next-line
    }, [tabSelected]);

    // Componente da aba atual
    const SelectedComponent = useMemo(() => {
        return tabs.find((tab) => tab.label === tabSelected)?.component || null;
        // eslint-disable-next-line
    }, [tabSelected]);

    // Busca filtros
    useQuery({
        queryFn: () => {
            const abortController = new AbortController();
            return service.getFilterOptions(abortController.signal);
        },
        queryKey: [queryKey],
        onSuccess: (data) => {
            setFilterOptions(data);
        },
    });

    return (
        <Grid container spacing={2}>
            <ThemeProvider theme={theme}>
                <Heading
                    as="h1"
                    size="large"
                    font="Campuni"
                    style={{display: "flex", marginRight: 40, marginLeft: 40}}
                >
                    {title}:
                    <SEText color="#0061C6" style={{marginLeft: 4}}>
                        {tabSelected}
                    </SEText>
                </Heading>

                {SelectedComponent && (
                    <Box paddingLeft={5} paddingTop={3} width="100%">
                        <SelectedComponent
                            tabSelected={tabSelected}
                            setTabSelected={setTabSelected}
                            tabs={tabs.map((t) => t.label)}
                            tipoAtendimento={tipoAtendimento}
                            exportFilenamePrefix={exportFilenamePrefix}
                        />
                    </Box>
                )}
            </ThemeProvider>
        </Grid>
    );
};
